import './Button.scss';

import * as React from 'react';
import { makeTranslatable, TranslatableType } from '../interfaces/Translatable';
import { TestableInterface } from '../interfaces/TestableInterface';
import { GlobalEvents } from '../../../Other/GlobalEvents';
import LoadingSpinner from '../LoadingSpinner';

export enum ButtonType {
  accept, normal, premium, link, cancel, filter, filterDropdDown, blue, red, acceptDisabled
}

export interface ButtonProps extends TestableInterface {
  label: TranslatableType;
  type?: ButtonType;
  action?: () => void;
  automation?: string;
  disabled?: boolean;
  selected?: boolean;
  premium?: boolean;
  className?: string;
  showLoadingAnimation?: boolean;
}

export interface ButtonState {
  menuOpen: boolean;
}

export class Button extends React.Component<ButtonProps, ButtonState> {
  private buttonRef;

  constructor(props) {
    super(props);
    // Set default state
    this.state = {
      menuOpen: false
    };
    this.buttonRef = React.createRef();
  }

  // Set default props
  public static defaultProps: ButtonProps = {
    label: 'Button',
    type: ButtonType.normal,
    automation: '',
    disabled: false,
    selected: false,
    premium: false,
    action: () => {
      return;
    }
  };

  /**
   * Internal function for button to react to click events and only accept single one at a time
   *
   * @param e
   */
  private reactToClick(e: Event) {
    if (!this.props.disabled && !this.props.showLoadingAnimation) {
      this.props.action();
    }
  }

  private e;

  public componentDidMount() {
    this.e = GlobalEvents.Click((e) => {
      this.setState({ menuOpen: false });
    });
  }

  public componentWillUnmount() {
    GlobalEvents.unBind(this.e);
  }

  public UNSAFE_componentWillUpdate(nextProps) {
    if (!this.props.showLoadingAnimation && nextProps.showLoadingAnimation) {
      this.buttonRef.current.style.width = this.buttonRef.current.offsetWidth + 'px';
    }
  }

  public render(): JSX.Element {
    const { automation, className, type, disabled, label, action,
      selected, premium, showLoadingAnimation = false, children } = this.props;

    const classes = ['Button', ButtonType[type]];
    if (className) { classes.push(className); }
    let star: JSX.Element = null;
    if (disabled) {
      classes.push('disabled');
    }

    if (selected) {
      classes.push('selected');
    }

    if (premium) {
      star = <img className="premium-star" src="/images/premiumfeature/star_with_circle_green.svg" />;
    }

    const numChildren = React.Children.count(children);

    if (numChildren > 0) {
      let menu = null;
      if (this.state.menuOpen) {
        menu = (
          <div className="button-menu " onClick={() => {
            this.setState({ menuOpen: false });
          }}>
            {children}
          </div>
        );
      }

      return (
        <div className={classes.join(' ') + ' button-menu-div'}>
          <div data-automation={automation} className={'menu-base'} onClick={() => {
            if (!showLoadingAnimation) { action(); }
            this.setState({ menuOpen: false });
          }}>
            {
              showLoadingAnimation ? <LoadingSpinner /> : (
                <>
                  {star}
                  {makeTranslatable(label)}
                </>)
            }
          </div>
          <div data-automation={automation + '-menu'} className={'dropdown'} onClick={(e) => {
            this.setState({ menuOpen: !this.state.menuOpen });
            GlobalEvents.stop(e);
            return false;
          }}>
          </div>
          {menu}
        </div>
      );
    } else {
      return (
        <div ref={this.buttonRef} data-automation={automation} className={classes.join(' ')}
          onClick={this.reactToClick.bind(this)}>
          {
            showLoadingAnimation ? <LoadingSpinner /> : (
              <>
                {star}
                {makeTranslatable(label)}
              </>)
          }
        </div>
      );
    }

  }
}
